export default __webpack_public_path__ + "static/media/development plan icon.9decb78c.svg";